import type { TMessages } from '@/types/TMessages'

export const messages = {
  action: 'Отправить',
  skip: 'Пропустить',
} as const satisfies TMessages
